import React from 'react';

/**
 * LoadingOverlay - A reusable pulsing loading indicator component
 * 
 * @param {boolean} isLoading - Whether to show the loading overlay
 * @param {string} message - Optional message to display (e.g., "Analyzing...", "Uploading...")
 * @param {string} className - Optional additional CSS classes
 */
export default function LoadingOverlay({ isLoading, message = 'Loading...', className = '' }) {
  if (!isLoading) return null;

  return (
    <div className={`loading-overlay ${className}`}>
      <div className="loading-overlay-content">
        <div className="loading-spinner"></div>
        {message && <p className="loading-message">{message}</p>}
      </div>
    </div>
  );
}
